export default {
  xs: "400px",
};
